import { Photo } from '../components/Photo';
import { ROUTES, useLocale } from '../i18n/locale';
import { sectionId } from '../content/site';
import { HOME, INDUSTRY_PHOTOS, OTHERS_PHOTO } from './content';
import { Lines } from './Lines';

/** Tier 1 verticals (docs/bos/03) and other planned B2B procurement; phones swipe, tablets use 2 × 2. */
export function Industries() {
  const { locale } = useLocale(); const copy = HOME[locale].industries;
  return (
    <section id={sectionId('industries', locale)} className="industries" data-tone="light" aria-labelledby="industries-title">
      <div className="industries__inner wrap">
        <header className="section-head industries__head">
          <h2 id="industries-title" className="section-title"><Lines lines={copy.title} /></h2>
          <p className="section-body">{copy.body}</p>
        </header>
        <ul className="industries__list" role="list">
          {copy.items.map((item, index) => (
            <li key={item.name} className="industry">
              <Photo id={INDUSTRY_PHOTOS[index]} alt={item.alt} sizes="(min-width: 1200px) 30vw, (min-width: 768px) 46vw, 82vw" className="industry__photo" />
              <h3 className="industry__name">{item.name}</h3>
              <p className="industry__body">{item.body}</p>
            </li>
          ))}
          <li className="industry">
            <Photo id={OTHERS_PHOTO} alt={copy.others.alt} sizes="(min-width: 1200px) 30vw, (min-width: 768px) 46vw, 82vw" className="industry__photo" />
            <h3 className="industry__name">{copy.others.name}</h3>
            <p className="industry__body">{copy.others.body}</p>
            <a className="industry__link" href={ROUTES.intake[locale]}>{copy.others.action}</a>
          </li>
        </ul>
      </div>
    </section>
  );
}
